import { apiFetch } from './client';
import type { FlaggedPage, Page, PageFlagName, SingleResponse } from './types';

export async function fetchPage(slug: string): Promise<Page> {
  const res = await apiFetch<SingleResponse<Page>>(`/api/v1/pages/${encodeURIComponent(slug)}`);
  return res.data;
}

export async function fetchPagesByFlag(flag: PageFlagName): Promise<FlaggedPage[]> {
  const res = await apiFetch<SingleResponse<FlaggedPage[]>>(
    `/api/v1/pages/flag/${encodeURIComponent(flag)}`,
  );
  return res.data;
}
